import { Helmet } from 'react-helmet-async';
import { ShieldCheck } from 'lucide-react';

export default function ParentalConsentPage() {
  return (
    <>
      <Helmet>
        <title>Parental Consent Review | DIGGER</title>
      </Helmet>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-foreground flex items-center gap-2">
            <ShieldCheck className="w-6 h-6 text-primary" />
            Parental Consent Review
          </h1>
          <p className="text-muted-foreground mt-1">Revisão e aprovação de consentimentos parentais.</p>
        </div>
        <div className="card p-12 flex flex-col items-center justify-center text-center gap-4">
          <ShieldCheck className="w-12 h-12 text-muted-foreground/40" />
          <p className="text-lg font-medium text-muted-foreground">Em construção</p>
          <p className="text-sm text-muted-foreground/60">Esta secção estará disponível em breve.</p>
        </div>
      </div>
    </>
  );
}
